// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Card_cardWrapper__3nGTM","detailTitle":"Card_detailTitle__1jCeR","label":"Card_label__2Y7JW"};